import {LayoutConfigModel} from '../_base/layout';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		'layout': 'oxalis-heart',
		// == Base Layout
		'self': {
			'layout': 'fluid', // fluid|boxed
			'body': {
				'background-image': './assets/media/misc/bg-oxalis.jpg',
			},
			'logo': {
                'dark': './assets/media/logos/logo_oxalis.png',
                'light': './assets/media/logos/logo_oxalis_dark.png',
                'brand': './assets/media/logos/logo_oxalis.png',
                'green': './assets/media/logos/logo_oxalis.png',
			},
		},
		// == Page Splash Screen loading
		'loader': {
			'enabled': true,
			'type': 'spinner-logo',
			'logo': './assets/media/logos/logo-mini-oxalis.png',
			'message': 'Please wait...',
		},
		// == Colors for javascript
		'colors': {
			'state': {
                'brand': '#017c38',
				'dark': '#004e0e',
				'light': '#53c477',
                'primary': '#017c38',
				'success': '#004e0e',
				'info': '#004c7e',
				'warning': '#ca5e00',
				'danger': '#d93024',
			},
			'base': {
				'label': [
					'#ebebeb',
					'#d3d3d9',
					'#9e9e9e',
					'#606062',
					'#424242',
					'#1f1f20',
				],
				'shape': [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a',
				],
			},
		},
		'header': {
			'self': {
				'skin': 'dark',
				'fixed': {
					'desktop': true,
					'mobile': true,
				},
			},
			'menu': {
				'self': {
					'display': true,
					'layout': 'default',
					'root-arrow': false,
				},
				'desktop': {
					'arrow': true,
					'toggle': 'click',
					'submenu': {
						'skin': 'light',
						'arrow': true,
					},
				},
				'mobile': {
					'submenu': {
						'skin': 'light',
						'accordion': true,
					},
				},
			},
		},
		'subheader': {
			'display': false,
			'layout': 'subheader-v1',
            'fixed': false,
			'width': 'fluid',
			'style': 'solid',
		},
		'content': {
			'width': 'fluid',
		},
		'brand': {
			'self': {
				'skin': 'dark',
			},
		},
		'aside': {
			'self': {
				'skin': 'light',
				'display': true,
				'fixed': true,
				'minimize': {
					'toggle': true,
					'default': false,
				},
			},
			'footer': {
				'self': {
					'display': true,
				},
			},
			'menu': {
				'dropdown': false,
				'scroll': false,
				'submenu': {
					'accordion': true,
					'dropdown': {
						'arrow': true,
						'hover-timeout': 500,
					},
				},
			},
		},
		'footer': {
			'self': {
                'width': 'fluid',
                'display': false,
			},
		},
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		return this.defaults;
	}
}
